import React from "react";
import { motion } from "framer-motion";
import { FileText, SlidersHorizontal, ShieldCheck, Clock } from "lucide-react";
import { useLang } from "@/i18n";

const icons = [FileText, SlidersHorizontal, ShieldCheck, Clock];

export const Process = () => {
  const { t } = useLang();
  return (
    <section className="relative py-24 sm:py-32 max-w-7xl mx-auto px-5 sm:px-8" data-testid="process">
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-accent mb-3">Modus Operandi</p>
          <h2 className="font-display text-3xl sm:text-5xl font-bold">{t.process.title}</h2>
          <p className="mt-4 text-muted-foreground text-lg">{t.process.subtitle}</p>
          <div className="mt-8 inline-flex items-center gap-3 rounded-2xl glow-border glass px-6 py-4 accent-glow">
            <Clock className="w-8 h-8 text-accent" strokeWidth={1.5} />
            <div>
              <p className="font-display text-2xl font-bold">48h</p>
              <p className="text-xs text-muted-foreground">{t.hero.stat2}</p>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {t.process.steps.map((step, i) => {
            const Icon = icons[i];
            return (
              <motion.div key={i}
                initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.1 }}
                className="flex gap-4 rounded-xl border border-white/10 bg-card p-5 hover:border-accent/30 transition-colors" data-testid={`process-step-${i}`}>
                <div className="w-11 h-11 shrink-0 rounded-xl bg-accent/10 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-accent" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="font-display font-semibold">{step.t}</h3>
                  <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{step.d}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
